import { z } from "zod";

export const EntityChangeWarningsSchema = z.object({
    hasDocumentsToTransfer: z.boolean(),
    documentsCount: z.number(),
    hasJournalEntriesToTransfer: z.boolean(),
    transferError: z.string().nullable(),
});

export const IntegrationSyncStatusSchema = z.object({
    isIntegrationSyncInFlight: z.boolean(),
});

export type IntegrationSyncStatus = z.infer<typeof IntegrationSyncStatusSchema>;
